import React from "react";
import {Row ,Col } from 'antd';


const baseUrlPath = "/schoolMng"; //学校信息管理模块路径

/**
 * 学校信息查看表单
 * @author yizhiqiang
 * @Email yizhiqiang@ly-sky.com
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {

        const {editData} = this.props;

        return (
            <div>
                <Row>
                    <Col span={8} style={{textAlign:'right'}}>标题:</Col>
                    <Col span={16}>{editData.bt}</Col>
                 </Row>
                 <Row>
                    <Col span={8} style={{textAlign:'right'}}>标题:</Col>
                    <Col span={16}>{editData.bt}</Col>
                 </Row>
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/face/ViewForm.js